import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";

const ContactSection = () => {
  const [contactData, setContactData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formLoading, setFormLoading] = useState(false);

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await fetch("https://server.enjoywiki.com/youtubeai-may/api/contact-section");
        if (!response.ok) {
          throw new Error("Failed to fetch contact section data");
        }
        const data = await response.json();
        if (!data.success) {
          throw new Error(data.message || "Failed to fetch contact section data");
        }
        setContactData(data.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching contact section data:", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchContactData();
  }, []);

  const UserContactMessage = (event) => {
    event.preventDefault();
    setFormLoading(true);
    
    // Fixed don't change it: Using correct form field names that match the input names
    const ticketUserName = event.target.name.value;
    const ticketUserEmail = event.target.email.value;
    const message = event.target.message.value;
    const subject = event.target.subject.value;
    const phone = event.target.phone ? event.target.phone.value : "";
    const ticketStatus = "open";
    const contact = {
      ticketUserName,
      ticketUserEmail,
      message,
      subject,
      phone,
      ticketStatus,
      createdAt: new Date(),
      ticketUserRole: "user",
    };
    
    const url = `/new-support-message`;
    fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(contact),
    })
      .then((res) => res.json())
      .then((result) => {
        event.target.reset();
        toast.success("Message Sent Successfully!");
        setFormLoading(false);
      })
      .catch((error) => {
        toast.error("Failed to send message. Please try again.");
        console.error("Error sending message:", error);
        setFormLoading(false);
      });
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden"></span>
        </div>
       
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger m-4" role="alert">
        Error: {error}
      </div>
    );
  }

  if (!contactData || !contactData.isActive) {
    return null; // Don't render if inactive or no data
  }

  return (
    <>
      <section className="address_area section-padding">
        <div className="container">
          <div className="row text-center">
            {contactData.contactInfo.map((info) => (
              <div
                key={info.id}
                className="col-lg-4 col-sm-4 col-xs-12 wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay="0.1s"
                data-wow-offset={0}
              >
                <div className="single_address">
                  <i className={info.iconClass} />
                  <h4>{info.title}</h4>
                  <p dangerouslySetInnerHTML={{ __html: info.content }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <div id="contact" className="contact_area section-padding">
        <div className="container">
          <div className="section-title-two">
            <h2>{contactData.sectionTitle}</h2>
          </div>
          <div className="row">
            <div
              className="offset-lg-1 col-lg-10 col-sm-12 col-xs-12 wow fadeInUp"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
              data-wow-offset={0}
            >
              <div className="contact">
                <form
                  className="form"
                  name="enq"
                  method="post"
                  onSubmit={UserContactMessage}
                >
                  <div className="row">
                    {contactData.formFields.map((field) => (
                      <div key={field.name} className={`form-group ${field.colWidth}`}>
                        <label htmlFor={field.name}>{field.label}</label>
                        {field.type === "textarea" ? (
                          <textarea
                            rows={6}
                            name={field.name}
                            className="form-control"
                            required={field.required}
                          />
                        ) : (
                          <input
                            type={field.type}
                            name={field.name}
                            className="form-control"
                            required={field.required}
                          />
                        )}
                      </div>
                    ))}
                    <div className="col-md-12 text-center">
                      <button
                        type="submit"
                        value={contactData.buttonText}
                        name="submit"
                        id="submitButton"
                        className="home_one"
                        title="Submit Your Message!"
                        disabled={formLoading}
                      >
                        {formLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Sending...
                          </>
                        ) : (
                          contactData.buttonText
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactSection;